export interface BedbankDisplayPricing {
  price: number
  memberPrice?: number
  propertyFees: number
  total: number
  memberTotal?: number
  value: number
}

interface BedbankDisplayPricingOptions {
  fallback?: BedbankDisplayPricing
}

export function getBedbankMemberAccommodationPrice(rate: App.BedbankRate): number | undefined {
  const { memberInclusive } = rate.totals
  return memberInclusive && memberInclusive > 0 ? memberInclusive : undefined
}

/**
 * Resolves the Bedbank prices presented to customers.
 *
 * `inclusive`/`memberInclusive` remain the source prices and property fees are
 * added exactly once to sell prices. Bedbank `value` is property-inclusive
 * compare-at when present; otherwise it falls back to the resolved all-in
 * `total`. A fallback preserves flight-bundle behaviour when a bundle rate
 * omits or zeroes price, member price, or property fees. Explicit `total`
 * fields on the rate are deliberately not used as a second source of truth.
 */
export function getBedbankDisplayPricing(
  rate: App.BedbankRate,
  options: BedbankDisplayPricingOptions = {},
): BedbankDisplayPricing {
  const price = rate.totals.inclusive || options.fallback?.price || 0
  const memberPrice = getBedbankMemberAccommodationPrice(rate) ?? options.fallback?.memberPrice
  const propertyFees = rate.totals.propertyFees || options.fallback?.propertyFees || 0
  const total = price + propertyFees

  return {
    price,
    memberPrice,
    propertyFees,
    total,
    memberTotal: memberPrice == null ? undefined : memberPrice + propertyFees,
    value: rate.value || total,
  }
}
